import _ from "lodash";
import { FormSubmissionPrivacyType } from "src/constants";
import type { FormSubmissionDetailDto, UserDto } from "src/http";

export const getFormSubmissionViewers = (formSubmission: FormSubmissionDetailDto): UserDto[] => {
  switch (formSubmission.privacySetting) {
    case FormSubmissionPrivacyType.Public:
    default:
      return [];
    case FormSubmissionPrivacyType.RecipientAndPeopleLead: {
      const users: UserDto[] = [];

      users.push(formSubmission.createdByUser);
      users.push(...formSubmission.priviledgedUsers);

      if (formSubmission.recipientUser) {
        users.push(formSubmission.recipientUser);
      }

      if (formSubmission.recipientUserPeopleLead) {
        users.push(formSubmission.recipientUserPeopleLead);
      }

      return _.uniqBy(users, (x) => x.userId);
    }
    case FormSubmissionPrivacyType.RecipientOnly: {
      const users: UserDto[] = [formSubmission.createdByUser];

      if (formSubmission.recipientUser) {
        users.push(formSubmission.recipientUser);
      }

      return _.uniqBy(users, (x) => x.userId);
    }
  }
};
